import * as THREE from 'three';
import Stats from 'three/examples/jsm/libs/stats.module';

import Simulator from '../simulator';
import { ThreeJSClass, ThreeJSColours } from '../threejs.helper';

export default class Scene extends ThreeJSClass {
  _scene: THREE.Scene;
  // _gridLight: THREE.GridHelper;
  // _gridDark: THREE.GridHelper;
  // _groundLight: THREE.Mesh;
  // _groundDark: THREE.Mesh;

  _stats?: Stats;
  _axisHelper?: THREE.AxesHelper;

  constructor(simulation: Simulator) {
    super(simulation);
    this._scene = new THREE.Scene();
    // this._scene.background = this.getBackgroundColour(simulation._isDarkMode);
    // this._scene.fog = new THREE.Fog(
    //   this.getFogColour(simulation._isDarkMode),
    //   4,
    //   10
    // );

    // this._gridLight = this.createGrid(false);
    // this._gridDark = this.createGrid(true);
    // this._scene.add(this._gridLight);
    // this._scene.add(this._gridDark);

    // this._groundLight = this.createGround(false);
    // this._groundDark = this.createGround(true);
    // this._scene.add(this._groundLight);
    // this._scene.add(this._groundDark);

    this.addDebugTools();
  }

  createGrid(isDarkMode: boolean) {
    const grid = new THREE.GridHelper(
      40,
      20,
      this.getGridColour(isDarkMode),
      this.getGridColour(isDarkMode)
    );
    grid.material.opacity = 0.2;
    grid.material.transparent = true;
    grid.visible = isDarkMode
      ? this._simulation._isDarkMode
      : !this._simulation._isDarkMode;
    return grid;
  }

  createGround(isDarkMode: boolean) {
    const ground = new THREE.Mesh(
      new THREE.PlaneGeometry(40, 40),
      new THREE.MeshPhongMaterial({
        color: this.getGroundColour(isDarkMode),
        depthWrite: false,
      })
    );
    ground.rotation.x = -Math.PI / 2;
    ground.receiveShadow = true;
    ground.visible = isDarkMode
      ? this._simulation._isDarkMode
      : !this._simulation._isDarkMode;
    return ground;
  }

  addDebugTools() {
    this._axisHelper = new THREE.AxesHelper(5);
    this._scene.add(this._axisHelper);

    this._stats = new Stats();
    document.body.appendChild(this._stats.dom);

    if (!this._simulation.debug) {
      this._stats.dom.style.display = 'none';
      this._axisHelper.visible = false;
    }
  }

  getBackgroundColour(isDarkMode: boolean) {
    return new THREE.Color(
      isDarkMode
        ? ThreeJSColours.background.dark
        : ThreeJSColours.background.light
    );
  }

  getFogColour(isDarkMode: boolean) {
    return new THREE.Color(
      isDarkMode ? ThreeJSColours.fog.dark : ThreeJSColours.fog.light
    );
  }

  getGridColour(isDarkMode: boolean) {
    return new THREE.Color(
      isDarkMode ? ThreeJSColours.grid.dark : ThreeJSColours.grid.light
    );
  }

  getGroundColour(isDarkMode: boolean) {
    return new THREE.Color(
      isDarkMode ? ThreeJSColours.ground.dark : ThreeJSColours.ground.light
    );
  }

  onToggleTheme(isDarkMode: boolean): void {
    // this._scene.background = this.getBackgroundColour(isDarkMode);
    // if (this._scene.fog) this._scene.fog.color = this.getFogColour(isDarkMode);
    // if (isDarkMode) {
    //   this._gridDark.visible = true;
    //   this._groundDark.visible = true;
    //   this._gridLight.visible = false;
    //   this._groundLight.visible = false;
    // } else {
    //   this._gridLight.visible = true;
    //   this._groundLight.visible = true;
    //   this._gridDark.visible = false;
    //   this._groundDark.visible = false;
    // }
  }

  onTick(elapsedTime: number): void {
    if (this._stats) this._stats.update();
  }

  onToggleDebug(isDebug: boolean): void {
    if (this._stats) this._stats.dom.style.display = isDebug ? 'block' : 'none';
    if (this._axisHelper) this._axisHelper.visible = isDebug;
  }
  dispose(): void {
    this._scene.clear();
    if (this._stats) this._stats.dom.innerHTML = '';
  }
}
